import script from "./timeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./timeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./timeSelector.vue?vue&type=style&index=0&id=70d9ee2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d9ee2a"]])

export default __exports__